import DeleteListContainer from "./DeleteList";
export default DeleteListContainer;
